import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable, Subject } from "rxjs";
import { QuattroB2C } from "../models/quattroB2C.model";
import { StorageService } from "../services/storage.service";

@Injectable({
    providedIn: 'root'
})
export class ValidaLoggedGuard implements CanActivate {
    private subject = new Subject<boolean>();
    public quattroB2C: QuattroB2C = new QuattroB2C();

    constructor(private router: Router, private storageService: StorageService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        let isActive: boolean = false;
        try {
            if (this.storageService.ifExist("quattroB2C")) {
                this.quattroB2C = JSON.parse(this.storageService.getItem("quattroB2C")) as QuattroB2C;
                if (this.storageService.getItem("tkn") != '' && this.storageService.ifExist("isLogged")) {
                    isActive = true;
                } else {
                    this.router.navigate(["/principal"]);
                }
            } else {
                this.router.navigate(["/principal"]);
            }
        } catch (error) {
            isActive = false;
        }
        return isActive;
    }
}
